import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {
  VEHICLE_TYPE_ANIA_PROPS,
  VEHICLE_TYPE_MCTC_PROPS,
} from 'src/model/constants/vehicle-type-constants';
import { EPropsToMap } from 'src/model/enum/sic-ania/props-to-map.enum';
import * as dashboardConstants from '../model/constants/dashboard.constants';
import {
  RELATIVE_CATEGORY_MAP,
  RELATIVE_USE_MAP,
} from 'src/model/constants/sivi.constants';
import { IFinalListingResponse } from 'src/app/pages/sic-ania/interfaces/search.interface';
import { NEW_FORMAT_PLATE, OLD_FORMAT_PLATE, TEMPORARY_PLATE, NO_FILTER, CAR_TYPE } from 'src/model/constants/search.constants';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {

  emitSectionTitleSubject: Subject<string> = new Subject();

  originalOrder(): number {
    return 0;
  }

  manageErrors(errorMessages:any[], response: any | undefined) {
    if (!response) return;
    Object.entries(response.output).forEach(
      ([serviceName, value]: [any, any]) => {
        if (value.faultList) {
          errorMessages.push({
            section: serviceName,
            messages: value.faultList
          });
        }else if(value.error){
          errorMessages.push({
            section: serviceName,
            messages: [value.error]
          });
        }else{
          return
        }
      }
    );
  }


  parseStringifiedResponseInJSON(object:any){
    const parsedObject = {
      "output":{}
    } as IFinalListingResponse;   
    if(!object || Object.keys(object).length === 0)
      return
    
    Object.keys(object.output).forEach((sectionProp) => {
      if(!object.output[sectionProp].includes('Internal Server Error')){
          parsedObject.output = {
            ...parsedObject.output,
            [sectionProp]: JSON.parse(object.output[sectionProp])
          }
      }else{
          const splittedError = object.output[sectionProp].split(': "');
          const faultString = splittedError[1];
          parsedObject.output = {
            ...parsedObject.output,
            [sectionProp] : {
              error: true,
              faultList: faultString ? JSON.parse(faultString.substring(0,faultString.length-1)).faultList : []
            }
          
        }
      }
    })
    return parsedObject;
  }

  buildSummaryResponse(
    response: any,
    responseProp: any,
    summaryResp: any,
    prop: any
  ) {
    if (responseProp === prop.value) {
      summaryResp = {
        ...summaryResp,
        [responseProp]: response[responseProp],
      };
    }
    return summaryResp;
  }

  buildSummaryData(summaryProps: any[], response: any) {
    let summaryResp = {};
    summaryProps.forEach((prop) => {
      Object.keys(response).forEach((responseProp) => {
        summaryResp = this.buildSummaryResponse(
          response,
          responseProp,
          summaryResp,
          prop
        );
        if (prop.compositeValue) {
          prop.value.forEach((singleProp: any) => {
            summaryResp = this.buildSummaryResponse(
              response,
              responseProp,
              summaryResp,
              singleProp
            );
          });
        }
      });
    });
    return summaryResp;
  }


  setIdVeic(formData:any){
    let plate = formData['plate'] || formData['idVeic'];
    const plateType = formData['plateType'] || formData['formIdVeic'];
    const vehicleType = formData['vehicleType'] || formData['codTpVeic'] || formData['tipoVeicolo'];
    let provincia;
    let numero;
    if(NEW_FORMAT_PLATE.includes(plateType)){
       plate = plate.includes('*') ? plate : `*${plate}`;
    }
    if((OLD_FORMAT_PLATE.includes(plateType) || TEMPORARY_PLATE.includes(plateType)) && 
    ((!vehicleType || NO_FILTER.includes(vehicleType)) || CAR_TYPE.includes(vehicleType))){
      provincia = plate.substring(0,2);
      numero = plate.substring(2, plate.length);
      if(numero.length < 6){
        let zero = '';
        for(let i = 0; i < 6 - numero.length; i++){
          zero += '0'
        }
        numero = zero + numero;
      }
      plate = provincia + numero;
   }
   return plate.toUpperCase();
  }

  setCorrectDataToMap(prop: string) {
    let dataArray: any[] = [];
    const isCiclomotore = false;
    switch (prop) {
      case EPropsToMap.TIPO_VEIC_MCTC_LABEL:
        dataArray = VEHICLE_TYPE_MCTC_PROPS;
        break;
      case EPropsToMap.TIPO_VEIC_LABEL:
        dataArray = VEHICLE_TYPE_ANIA_PROPS;
        break;
      case EPropsToMap.PROVENIENZA:
        dataArray = dashboardConstants.COD_PROV_VEIC_PROPS;
        break;
      case EPropsToMap.TIPO_IMMATR:
        dataArray = dashboardConstants.TIPO_EMISSIONE_CARTA_PROPS;
        break;
      case EPropsToMap.TIPO_MOV:
        dataArray = dashboardConstants.TIPO_MOVIMENTO_PROPS;
        break;
      case EPropsToMap.CODICE_CAUS:
        dataArray = isCiclomotore
          ? dashboardConstants.CAUSALE_CARTA_CICLOMOTORI_PROPS
          : dashboardConstants.CAUSALE_CARTA_NON_CICLOMOTORI_PROPS;
        break;
      case EPropsToMap.CODICE_CAUS_ACI:
        dataArray = dashboardConstants.CAUSALE_ACI_PROPS;
        break;
      case EPropsToMap.TIPO_DENOM:
        dataArray = dashboardConstants.TIPO_DENOMINAZIONE_PROPS;
        break;
      case EPropsToMap.COD_ALIMENTA:
        dataArray = dashboardConstants.COD_ALIMENTAZIONE_PROPS;
        break;
      case EPropsToMap.CARROZZ_SPEC:
        dataArray = dashboardConstants.SPEC_CARROZZERIA_PROPS;
        break;
      case EPropsToMap.MOD_PAGAMENTO:
        dataArray = dashboardConstants.MOD_PAGAMENTO_PROPS;
        break;
      case EPropsToMap.TARIFFA:
        dataArray = dashboardConstants.FORMA_TARIFFARIA_PROPS;
        break;
      case EPropsToMap.TIPO_POLIZZA:
        dataArray = dashboardConstants.TIPO_POLIZZA_PROPS;
        break;
      case EPropsToMap.COD_LEGGE:
        dataArray = dashboardConstants.COD_LEGGE_PROPS;
        break;
      case EPropsToMap.EURO:
        dataArray = dashboardConstants.CLASSE_INQUINAMENTO_PROPS;
        break;
      case EPropsToMap.COD_CARROZZERIA:
        dataArray = dashboardConstants.CODICE_CARROZZERIA_PROPS;
        break;
      case EPropsToMap.TIPOLOGIA_SINISTRI:
        dataArray = dashboardConstants.TIPOLOGIA_SINISTRI_PROPS;
        break;
      case EPropsToMap.IMPRESA_DB_LABEL:
      case EPropsToMap.COD_IMP_CTP_LABEL:
        dataArray = dashboardConstants.COMPANY_CODES_PROPS;
        break;
      case EPropsToMap.CANALE_AGG_LABEL:
        dataArray = dashboardConstants.CANALE_AGG_PROPS;
        break;
      default:
    }

    return dataArray;
  }

  mapCodeToValue(response: any) {
    if (response) {
      Object.keys(response).forEach((prop: string) => {
        const dataArray = this.setCorrectDataToMap(prop);
        const impresaCode = prop === EPropsToMap.IMPRESA_DB_LABEL || 
        prop === EPropsToMap.COD_IMP_CTP_LABEL;
        
        dataArray.forEach((el) => {
          if(impresaCode && !isNaN(parseInt(el.key))){
            el.key = parseInt(el.key).toString();
          }
          if(prop === EPropsToMap.TIPO_MOV && el.key === response[prop]){
            el.causaleProps.forEach((causale:any) => {
              if(causale.key === response['causMov']){
                response['causMov'] = causale.label
              }
            })
          }
          if (el.key === response[prop]) {
            response = {
              ...response,
              [prop]:
                impresaCode
                  ? el.label.split('-')[0].trim()
                  : el.label,
            };
          }
        });
      });
    }
    return response;
  }

  private swapStringArray(stringArray: string[]) {
    let temp;
    for (let i = 0; i < stringArray.length / 2; i++) {
      temp = stringArray[i];
      stringArray[i] = stringArray[stringArray.length - i - 1];
      stringArray[stringArray.length - i - 1] = temp;
    }
  }

  private getHourOrDateStringFromArray(
    stringDateArray: string[],
    separatorChar: string
  ) {
    let correctDate = '';
    for (let i = 0; i < stringDateArray.length; i++) {
      let dateChar = stringDateArray[i] + separatorChar;
      if (i === stringDateArray.length - 1) {
        dateChar = stringDateArray[i];
      }
      correctDate += dateChar;
    }
    return correctDate;
  }

  getOldestDate(arr: any[], date: string) {
    const tempDate = new Date(arr[0][date]);
    let oldestDate;
    arr.forEach((item: any) => {
      if (new Date(item[date]) < tempDate) {
        oldestDate = item[date];
      }
    });
    return oldestDate;
  }

  sortArrayByMostRecentDate(arr: any[], date: string) {
    return [...arr].sort(
      (a, b) => new Date(b[date]).getTime() - new Date(a[date]).getTime()
    );
  }

  convertStringNumberInHour(stringHour: string) {
    let hour = '';
    if(stringHour){
      hour = stringHour[0] + stringHour[1] + ':' + stringHour[2] + stringHour[3];
    }
    return stringHour ? hour : '';
  }

  convertYYYYMMDDInDDMMYYYY(stringDate: string) {
    let correctDate = '';
    if(stringDate){
      const stringDateArray = stringDate.split('-');
      this.swapStringArray(stringDateArray);
      correctDate = this.getHourOrDateStringFromArray(stringDateArray, '/');
    }
    return stringDate === '0001-01-01' || !stringDate ? '' : correctDate;
  }


  setOneDecimalValueIfIsZero(stringNum: string) {
    let integerPart = '';
    let decimalPart = '';
    if(stringNum){
      integerPart = stringNum.split('.')[0];
      decimalPart = stringNum.split('.')[1];
    }
    return stringNum ? decimalPart === '000' || decimalPart === '00'
      ? integerPart + '.0'
      : stringNum : '';
  }

  addDaysToDate(date: string, numberOfDays: number) {
    let parsedDate = '';
    if (date) {
      const startDate = new Date(date);
      const days = numberOfDays * (60 * 60 * 24 * 1000);
      const newDate = new Date(startDate.getTime() + days);
      const dateYear = newDate.getFullYear();
      const dateDay =  newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
      const dateMonth = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
      parsedDate = dateYear + '-' + dateMonth + '-' + dateDay;
    }
    return parsedDate;
  }

  convertStringTimestampToDate(stringTimestamp: string, leaveSeconds: boolean) {
    let correctTimeStamp = '';
    if(stringTimestamp){
      let splittedTimestamp: string[] = stringTimestamp.split('.');
      const splittedDate = splittedTimestamp[0].split('-');
      let dateString = '';
      let hourString = '';
      splittedTimestamp.shift();
      splittedTimestamp.unshift(splittedDate[splittedDate.length - 1]);
      splittedDate.pop();
      if (!leaveSeconds) {
        splittedTimestamp = splittedTimestamp.slice(0, 2);
      } else {
        splittedTimestamp.pop();
      }
      this.swapStringArray(splittedDate);
      dateString = this.getHourOrDateStringFromArray(splittedDate, '/');
      hourString = this.getHourOrDateStringFromArray(splittedTimestamp, ':');
      correctTimeStamp = dateString + ' ' + hourString;
    }
    return stringTimestamp ? correctTimeStamp : '';
  }

  getUseValue(codCatuso: string): string {
    const secondbyte = codCatuso?.charAt(1);
    if (isNaN(parseInt(secondbyte))) {
      return '';
    } else {
      return RELATIVE_USE_MAP.get(secondbyte) || '';
    }
  }

  getCategoryValue(codCatuso: string): string {
    const firstbyte = codCatuso?.charAt(0);
    const secondbyte = codCatuso?.charAt(1);
    if (isNaN(parseInt(secondbyte))) {
      return RELATIVE_CATEGORY_MAP.get(codCatuso) || '';
    } else if (
      RELATIVE_USE_MAP.get(secondbyte) &&
      RELATIVE_CATEGORY_MAP.get(firstbyte)
    ) {
      return RELATIVE_CATEGORY_MAP.get(firstbyte) || '';
    } else {
      return '';
    }
  }

  removeNumericValue(string: string) {
    for (let i = 0; i < string.length; i++) {
      if (isNaN(parseInt(string[i]))) {
        string = string.substring(0, i + 1);
      }
    }
    return string;
  }


  changePlateLabelIfPlateTypeIsChassis(propArrays:any[], formData:any){
    let plateProp;
    propArrays.forEach((propArray) => {
      propArray.data.forEach((data:any[]) => {
        data.forEach((singleProp:any) => {
            if(singleProp.key === 'PLATE' || singleProp.key === 'CHASSIS'){
              plateProp = singleProp;
              plateProp.key = 'PLATE'
              if(formData.plateType === 'L' || formData.formIdVeic === 'L'){
                plateProp.key = 'CHASSIS'
              }
              singleProp = plateProp;
            }
        })
      })
    })
  }

  buildCoowner(index:number){
    const stringCoownerNumber = index + 1 < 10 ? '0' + (index + 1).toString() : (index + 1).toString();
    return {
      title: 'TEMPORARY-COOWNER-DATA',
      number: index + 1,
      data: [
        [
          {
            key: 'FISCAL-CODE',
            value: 'codiceFiscaleCMP' + stringCoownerNumber,
            type: 'string'
          },
          {
            key: 'RESIDENCE-PROVINCE',
            value: 'provResidenzaCMP'+ stringCoownerNumber,
            type: 'string'
          },
          {
            key: 'RESIDENCE-MUNICIPALITY',
            value: 'comuneResidenzaCMP'+ stringCoownerNumber,
            type: 'string'
          }
        ],
        [
          {
            key: 'OWNER-DENOMINATION-TYPE',
            value: 'tipoDenomCMP'+ stringCoownerNumber,
            type: 'string'
          },
          {
            key: 'ISTAT-RESIDENCE-PROVINCE-CODE',
            value: 'provResidenzaIstatCMP'+ stringCoownerNumber,
            type: 'string'
          },
          {
            key: 'ISTAT-RESIDENCE-MUNICIP-CODE',
            value: 'comuneResidenzaIstatCMP'+ stringCoownerNumber,
            type: 'string'
          }
        ]
      ]
    }
  }
}
